<template>
    <edit-method-component 
        :currentMethod="currentMethod" 
        @submitEditedMethod="handleSubmitEditedMethod" 
        @addAnalytes="handleAddAnalytes" 
        @back="handleBack" 
        @editAnalyte="handleEditAnalyte" 
        @deleteAnalyte="handleDeleteAnalyte" 
        @submitArchivedExperimentalDataset="handleSubmitArchivedExperimentalDataset">
    </edit-method-component>
</template>


<script>
import EditMethodComponent from '@/components/method/EditMethodComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "OpenMethod",
    components: {EditMethodComponent},
    
    data: function() {
        return {
            currentMethod: [],
            component_url: 'experiments/methods/',
        }
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentMethodID', 'auth_header'
        ])
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_METHOD_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global MethodId
        setMethodId: function(){
            this.CHANGE_METHOD_ID(this.currentMethod.id)
        },
        getMethod: function(){ 
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentMethod.id,
                    { headers: this.auth_header }
                )
                .then(response => {
                    this.currentMethod = response.data;
                })
                .catch(error => {
                    console.log("Something went wrong getting the current method in editmethod");
                });
        },

        handleAddAnalytes: function(newAnalyte) {
            // call api to add new analyte
            console.log("handleAddAnalytes: ", newAnalyte);
        },

        handleEditAnalyte: function(rebuiltAnalyte) {
            // call api to edit an analyte
            console.log("handleEditAnalyte: ", rebuiltAnalyte);
        },

        handleDeleteAnalyte: function(currentAnalyte) {
            // call api to edit an analyte
            console.log("handleDeleteAnalyte:", currentAnalyte);
        },
        handleBack: function(currentMethod) {
            this.$router.push({ name: "Methods", params: { id: currentMethod.id } });
        },
        handleSubmitArchivedExperimentalDataset: function(experimentalDataset) {
            axios
                .patch(`${this.base_url}${this.component_url}${experimentalDataset.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header 
                    }
                )
                .then(response => {
                    console.log("Experimental Dataset Successfully Archived:", experimentalDataset);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Dataset Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ViewAllExperimentalDatasets", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Dataset was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Experimental Dataset was not successfully Edited: ", error.response.data);
                });
        },

        handleSubmitEditedMethod: function(editedMethod) {
            //convert files to base64
            if(typeof editedMethod.method_file.name == 'string') {
                var reader1 = new FileReader()
                reader1.readAsDataURL(editedMethod.method_file)
                reader1.onload = () => {
                    var base64Str = reader1.result
                    var indexOfComma = base64Str.indexOf(',');
                    editedMethod.method_file = base64Str.slice(indexOfComma+1)

                    if(typeof editedMethod.method_description_file.name == 'string') {
                        var reader2 = new FileReader()
                        reader2.readAsDataURL(editedMethod.method_description_file)
                        reader2.onload = () => {
                            var base64Str = reader2.result
                            var indexOfComma = base64Str.indexOf(',');
                            editedMethod.method_description_file = base64Str.slice(indexOfComma+1)

                            axios
                                .patch(
                                    this.base_url + this.component_url + this.currentMethod.id,
                                    editedMethod,
                                    { 
                                        headers: this.auth_header 
                                    }
                                )
                                .then(response => {
                                    console.log("Analytical method Successfully Edited");
                                    this.loading = false;
                                    this.$toast.open({
                                        duration: 5000,
                                        message: `Analytical method Successfully Edited`,
                                        position: 'is-top',
                                        type: 'is-primary'
                                    })
                                    this.$router.push({ name: "Methods", params: {  } });
                                })
                                .catch(error => {
                                    this.loading = false;
                                    this.$toast.open({
                                        duration: 5000,
                                        message: `Analytical method was not successfully Edited`,
                                        position: 'is-top',
                                        type: 'is-danger'
                                    })
                                    this.$router.push({ name: "EditMethod", params: { id: response.data.id } });
                                    console.log("Analytical method was not successfully Edited");
                                });
                        }
                        reader2.onerror = (error) => {
                            // console.log('Error converting to base64: ', error);
                            editedMethod.method_description_file = 'Error converting to base64: ' + error
                        } 
                    } 
                }
                reader1.onerror = (error) => {
                    // console.log('Error converting to base64: ', error);
                    editedMethod.method_file = 'Error converting to base64: ' + error
                } 
            }
        }
    },

    mounted: function() {
        this.setBreadcrumb()
        if (this.$route.params.id) {
            this.currentMethod.id = this.$route.params.id;     
            this.getMethod();
            this.setMethodId()       
        }
        else {
            console.log("EditMethod view no router params.id")
            this.currentMethod.id = this.currentMethodID
            this.getMethod();
            this.setMethodId()
        }
    }
}
</script>
